export const THIRD_PARTY_PLATFORMS = ['全部', '云集', '小灯塔'];
export const THIRD_PARTY_ORDER_STATUS = [
  {
    name: '全部', // 默认
    number: 0,
  },
  {
    name: '待发货',
    number: 10040,
  },
  {
    name: '部分发货',
    number: 10045,
  },
  {
    name: '已发货',
    number: 10050,
  },
  {
    name: '发货失败',
    number: 10055,
  },
  {
    name: '退款中',
    number: 10060,
  },
  {
    name: '已退款',
    number: 10065,
  },
];



// WEBPACK FOOTER //
// ./src/screens/order/type.tsx